import { Section, money } from "./shared";
import { evaluatedMechanism } from "./mechanism";

export default function PortfolioImprovement({ data, currency }) {
  const risk = data?.metrics?.capital_at_risk || {};
  const improvementLabel = evaluatedMechanism(data) === "RETENTION"
    ? "Modeled protection added"
    : "Modeled exposure reduction";
  const items = [["Current exposure", risk.baseline], [improvementLabel, risk.reduction], ["Remaining exposure", risk.selected]];
  return <Section stage="Stage 2 — Understand Strategic Potential" title="Resilience Transition">
    <p className="mb-4 text-sm leading-6 text-slate-600">This transition connects the Current Position to the modeled resilience improvement and then to Strategic Potential. It explains how the analysis moves from today&apos;s capital at risk to the strongest modeled position. This transition is on a Capital-at-Risk basis and is not the accepted optimizer&apos;s EAL transition.</p>
    <div className="grid items-center gap-3 md:grid-cols-3">
      {items.map(([label, value]) => <div key={label} className="rounded-xl border border-slate-200 p-5 text-center"><p className="text-sm text-slate-500">{label}</p><p className="mt-2 text-xl font-semibold text-slate-900">{money(value, currency)}</p></div>)}
    </div>
  </Section>;
}
